var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Input, Segment } from "semantic-ui-react";
import { AsyncButton } from "@iscr/views/UIelems/AsyncButton";
import API_service from "../providers/API_service";
import { useUser } from "../Hooks";
import { Message } from "@iscr/views/UIelems/v2/Message";
import { PulseRewardsIcon } from "../UIelems/PulseRewardsIcon";
import { Link } from "react-router";
export const PulseRewards = ({ isUserSettings }) => {
    var _a, _b, _c;
    const u = useUser();
    const member_number = (_b = (_a = u === null || u === void 0 ? void 0 : u.prof) === null || _a === void 0 ? void 0 : _a.pulsemembership) === null || _b === void 0 ? void 0 : _b.member_number;
    const [open, setOpen] = useState(member_number ? false : true);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [form, setForm] = useState({ member_number });
    const [success, setSuccess] = useState(null);
    useEffect(() => {
        setForm({ member_number });
    }, [member_number]);
    if ((_c = app.site_status) === null || _c === void 0 ? void 0 : _c.disable_pulse_points_integration)
        return null;
    // at checkout, members don't need the prompt - unless they just linked their card here, so they see it saved
    if (!isUserSettings && member_number && !success)
        return null;
    const onClose = () => {
        setOpen(false);
        setForm({ member_number });
        setError(null);
    };
    const onSubmit = () => __awaiter(void 0, void 0, void 0, function* () {
        if (member_number === form.member_number)
            return onClose();
        setLoading(true);
        const params = { member_number: form.member_number };
        try {
            const res = yield API_service.load_data(`pulse_rewards/update_member_number`, params);
            if (res === null || res === void 0 ? void 0 : res.err) {
                setError(res.err);
                setSuccess("");
            }
            else {
                app.user.reload_profile();
                setSuccess("Pulse Rewards membership number updated.");
                setError("");
                app.trigger(app.events.USER_UPD);
                onClose();
            }
        }
        catch (err) {
            setError(err);
            setSuccess("");
        }
        finally {
            setLoading(false);
        }
    });
    const onOpen = () => __awaiter(void 0, void 0, void 0, function* () {
        setOpen(true);
    });
    return (_jsxs(Segment, { className: "flex flex-col gap-4", children: [_jsxs("h2", { className: "flex flex-row items-center gap-2 text-[var(--membership-pulse-purple)]", children: [_jsx(PulseRewardsIcon, { size: 18 }), " Pulse Rewards"] }), _jsx("span", { children: "As a Pulse Rewards member, you can collect points at InstantScripts." }), error && (_jsx("div", { children: _jsx(Message, { variant: "error", content: error }) })), success && (_jsx("div", { children: _jsx(Message, { variant: "success", content: success }) })), _jsxs("div", { className: "!pt-0 gap-4 flex-row flex", children: [_jsx(Input, { type: "text", name: "member_number", disabled: !open, className: "flex-1", icon: "member", value: form.member_number, placeholder: "Enter Pulse Rewards Membership Number", onChange: ({ target }) => setForm(Object.assign(Object.assign({}, form), { member_number: target.value })) }), _jsx(AsyncButton, { disabled: loading, loading: loading, primary: true, onClick: open ? onSubmit : onOpen, children: open ? "Save" : "Edit" })] }), _jsxs("div", { children: ["Not a Pulse Rewards member yet?", " ", _jsx("u", { children: _jsx(Link, { target: "_blank", to: app.settings.dev_env
                                ? "https://online-signupstage.pricelinecloud.com.au/online/customer/signup?entry=ITSC"
                                : "https://mypulserewards.com.au/online/customer/signup?entry=ITSC", children: "Join Pulse Rewards" }) }), "."] }), _jsxs("div", { children: ["*T&C's apply.", " ", _jsx("u", { children: _jsx(Link, { target: "_blank", to: "https://www.priceline.com.au/priceline-policies/pulse-rewards", children: "Visit here" }) }), " ", "for full terms and conditions."] })] }));
};
